import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"

const Header = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const path = location.pathname

  const getHeaderText = () => {
    if (path.includes("success")) {
      return t("success.page_header")
    } else if (path.includes("ticket-details")) {
      return t("details.page_header")
    } else {
      return t("selection.page_header")
    }
  }

  return (
    <header 
      className="shadow" 
      role="banner" 
      aria-label={t("header.page_header", "Page header")}
    >
      <div className="container mx-auto px-4 py-6 flex justify-center">
        <h2 className="text-xl font-semibold" id="page-heading">{getHeaderText()}</h2>
      </div>
    </header>
  )
}

export { Header }
